module.exports = __webpack_public_path__ + "images/category_lp/brand_samples/pattern_a02/btn_sp_02c0596f90d6c29840f1c7887aa2cda0.png";